import { render, staticRenderFns } from "./digitalArchive.vue?vue&type=template&id=7edc0790&scoped=true"
import script from "./digitalArchive.vue?vue&type=script&lang=js"
export * from "./digitalArchive.vue?vue&type=script&lang=js"
import style0 from "./digitalArchive.vue?vue&type=style&index=0&id=7edc0790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edc0790",
  null
  
)

export default component.exports